export default function KPICard({ label, value, hint, accentColor, testId }) {
  return (
    <div className="ifl-card p-6 flex flex-col h-full ifl-fade-up" data-testid={testId}>
      <div className="flex items-start justify-between">
        <span className="label-caps">{label}</span>
        {accentColor ? <span className="ifl-status-dot" style={{ background: accentColor }} /> : null}
      </div>
      <div className="font-display font-medium mt-4" style={{ fontSize: "2rem", lineHeight: 1, color: "var(--ifl-text)" }}>
        {value}
      </div>
      {hint ? (
        <div className="font-body text-xs mt-3" style={{ color: "var(--ifl-muted)" }}>
          {hint}
        </div>
      ) : null}
    </div>
  );
}
